import React, { useState, useEffect } from 'react';
import {
    Grid,
    Box,
    Typography,
    Divider,
    Paper,
} from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import { CloseIcon, Mail } from '../../../assets';
import { CustomButton } from '../../shared';
import 'react-phone-input-2/lib/style.css';

function CreateNewCompany(props) {
    const { handleClose, type, handleSubmit, initialCompanyData } = props;
    const [companyData, setCompanyData] = useState(initialCompanyData);

    const handleFormSubmit = () => {
        handleSubmit();
        handleClose();
    };

    return (
        <Grid container className='custom-modal-inner-container'>
            <Grid item xs={12}>
                <Box className="padding-24px">
                    {/* Create new company */}
                    <Box className="flex-row-space-between pb-24px">
                        <Typography className='text-lg-medium gray-900'>
                        {type === 'create' ? 'Create new company' : 'Edit Company Details'}
                        </Typography>
                        <Box className="icon" onClick={handleClose}>
                            <CloseIcon color="#98A2B3" width='12' height='12' />
                        </Box>
                    </Box>

                    {/* Company Name */}
                    <Box className="flex-column gap-6 w-100 pb-24px">
                        <Typography className="text-sm-medium gray-700">
                            Company Name
                        </Typography>
                        <input
                            type="text"
                            placeholder='Enter Company Name'
                            className="custom-text-field padding-tb-10-rl-14 gray-900"
                            value={companyData.companyName} 
                            onChange={(e) => setCompanyData({ ...companyData, companyName: e.target.value })}
                        />
                    </Box>
                    {/* Contact Name */}
                    <Box className="flex-column gap-6 w-100 pb-24px">
                        <Typography className="text-sm-medium gray-700">
                            Contact Name
                        </Typography>
                        <input
                            type="text"
                            placeholder='Enter Contact Name'
                            className="custom-text-field padding-tb-10-rl-14 gray-900"
                        />
                    </Box>
                    {/* Contact Email */}
                    <Box className="flex-column gap-6 w-100 pb-24px">
                        <Typography className="text-sm-medium gray-700">
                            Contact Email
                        </Typography>
                        <Box className="flex-row-start-center gap-8 custom-text-field padding-tb-10-rl-14">
                            <Mail />
                            <input
                                type="email"
                                placeholder='Enter email'
                                className="text-md-regular w-100 border-outline-none gray-900"
                            />
                        </Box>
                    </Box>
                    {/* Contact Phone */}
                    <Box className="flex-column gap-6 pb-24px w-50">
                        <Typography className="text-sm-medium gray-700">
                            Contact Phone
                        </Typography>
                        <Box className="">
                            <PhoneInput
                                country={'us'}
                                // value={phone}
                                // onChange={PHONE => setPhone({ phone })}
                                inputClass="phone-input-class"
                                buttonClass="phone-input-button-class"
                                containerClass='phone-input-container-class'
                            />
                        </Box>
                    </Box>
                    {/* Territories */}
                    <Box className="flex-column gap-6 w-100 pb-24px">
                        <Typography className="text-sm-medium gray-700">
                            Territories
                        </Typography>
                        <input
                            type="text"
                            placeholder='For Example Texas'
                            className="custom-text-field padding-tb-10-rl-14 gray-900"
                        />
                    </Box>
                    {/* Active User Limit */}
                    <Box className="flex-column gap-6 w-100 pb-24px w-25">
                        <Typography className="text-sm-medium gray-700">
                            Active User Limit
                        </Typography>
                        <input
                            type="text"
                            className="custom-text-field padding-tb-10-rl-14 gray-900"
                        />
                    </Box>
                    {/* Subscription Date */}
                    <Box className="flex-row-space-between gap-24 w-100 pb-24px">
                        <Box className="w-50">
                            <Typography className="text-sm-medium gray-700">
                                Subscription Start Date
                            </Typography>
                            <input
                                type="date"
                                className="custom-text-field padding-tb-10-rl-14 gray-900"
                            />
                        </Box>
                        <Box className="w-50">
                            <Typography className="text-sm-medium gray-700">
                                Subscription End Date
                            </Typography>
                            <input
                                type="date"
                                className="custom-text-field padding-tb-10-rl-14 gray-900"
                            />
                        </Box>
                    </Box>



                </Box>
            </Grid>

            <Grid item xs={12} className='custom-modal-sticky-container'>
                <Divider className="border-1-gray" />
                <Box className="flex-row-end-center gap-12 padding-tb-16-rl-24">
                    <CustomButton
                        title="Cancel"
                        handleClick={handleClose}
                    />
                    <CustomButton
                        title={type === 'create' ? 'Create Company' : 'Update Company'}
                        titleColor="#FFFFFF"
                        buttonColor="#AD509E"
                        handleClick={handleFormSubmit}
                    />
                </Box>
            </Grid>
        </Grid>

    )
};

CreateNewCompany.defaultProps = {
    type: 'create',
    initialCompanyData: {
        companyName: '',
        contactName: '',
        contactEmail: '',
        contactPhone: '',
        territories: '',
        activeUserLimit: '',
        subscriptionStartDate: '',
        subscriptionEndDate: '',
    },
    handleSubmit: () => {},
};


export default CreateNewCompany;